import moment from "moment";
import { POST, SUCCESS } from "../utils/const/http-const";
import { getHeaders } from "./utils";

export async function createConductor(obj) {
  try {
    let response = { error: true };
    const { code, body } = await fetch(
      "https://gestiondeflota.boltrack.net/apiultimamillav3/api/conductor/crear-conductor",
      {
        headers: getHeaders(),
        method: POST,
        body: JSON.stringify(obj),
      }
    ).then((res) => res.json());
    // console.log('code');
    // console.log(code);
    // console.log('body');
    // console.log(body);
    if (code === SUCCESS) {
      response.error = false;
      response.value = body;
    }
    return response;
  } catch (err) {
    console.log("createConductor err");
    console.log(err);
    return { error: true };
  }
}

export async function obtenerListaConductores(obj, combo = false) {
  try {
    let response = [];
    const { code, body } = await fetch(
      "https://gestiondeflota.boltrack.net/apiultimamillav3/api/conductor/obtener-lista-conductores",
      {
        headers: getHeaders(),
        method: POST,
        body: JSON.stringify(obj),
      }
    ).then((res) => res.json());
    // console.log('code');
    // console.log(code);
    // console.log('body');
    // console.log(body);
    if (code === SUCCESS) {
      if (combo === false) {
        response = body;
        for (let i = 0; i < response.length; i++) {
          response[i].fechaProceso = moment(response[i].fechaProces).format('DD/MM/YYYY HH:mm');
        }
      }
      if (combo === true) {
        response = body.map((item) => {
          return {
            value: item.id,
            label: item.nombre,
          };
        });
      }
    }
    return response;
  } catch (err) {
    console.log("obtenerListaConductores err");
    console.log(err);
    return [];
  }
}

export async function actualizarConductor(obj) {
  try {
    let response = { error: true };
    const { code } = await fetch(
      "https://gestiondeflota.boltrack.net/apiultimamillav3/api/conductor/actualizar-conductor",
      {
        headers: getHeaders(),
        method: POST,
        body: JSON.stringify(obj),
      }
    ).then((res) => res.json());
    // console.log('code');
    // console.log(code);
    // console.log('body');
    // console.log(body);
    if (code === SUCCESS) {
      response.error = false;
    }
    return response;
  } catch (err) {
    console.log("actualizarConductor err");
    console.log(err);
    return { error: true };
  }
}

export async function deshabilitarConductor(obj) {
  try {
    let response = { error: true };
    const { code } = await fetch(
      "https://gestiondeflota.boltrack.net/apiultimamillav3/api/conductor/deshabilitar-conductor",
      {
        headers: getHeaders(),
        method: POST,
        body: JSON.stringify(obj),
      }
    ).then((res) => res.json());
    // console.log('code');
    // console.log(code);
    // console.log('body');
    // console.log(body);
    if (code === SUCCESS) {
      response.error = false;
    }
    return response;
  } catch (err) {
    console.log("deshabilitarConductor err");
    console.log(err);
    return { error: true };
  }
}

export async function habilitarConductor(obj) {
  try {
    let response = { error: true };
    const { code } = await fetch(
      "https://gestiondeflota.boltrack.net/apiultimamillav3/api/conductor/habilitar-conductor",
      {
        headers: getHeaders(),
        method: POST,
        body: JSON.stringify(obj),
      }
    ).then((res) => res.json());
    // console.log('code');
    // console.log(code);
    // console.log('body');
    // console.log(body);
    if (code === SUCCESS) {
      response.error = false;
    }
    return response;
  } catch (err) {
    console.log("habilitarConductor err");
    console.log(err);
    return { error: true };
  }
}